'use client';

import { cn } from '@/lib/utils';

const variants = {
  slate: 'bg-slate-100 text-slate-600',
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  amber: 'bg-amber-100 text-amber-700',
  red: 'bg-red-100 text-red-700',
  purple: 'bg-purple-100 text-purple-700',
  gray: 'bg-gray-100 text-gray-600',
};

export default function Badge({
  children,
  variant = 'slate',
  className,
}) {
  return (
    <span className={cn(
      'inline-block px-2 py-0.5 text-xs font-medium rounded-md',
      variants[variant],
      className
    )}>
      {children}
    </span>
  );
}
